import apiClient from '../api/apiClient';

/** Unwrap common API envelope { success, data } */
function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

const investorService = {
  /**
   * GET /api/v1/admin/investors — Fetch paginated investors for admin dashboard
   * Response: { data: { users: [...], pagination: {...}, statistics: {...} } }
   */
  getAdminInvestors: async (params = {}) => {
    const { signal, ...rest } = params;
    const defaultParams = {
      page: 1,
      limit: 10,
      search: '',
      status: 'all',
      sort_by: 'created_at',
      sort_order: 'desc',
      start_date: '',
      end_date: '',
      manager_id: '',
      rm_uuid: '',
      ...rest,
    };
    if (!defaultParams.active_in_period) {
      delete defaultParams.active_in_period;
    }
    const response = await apiClient.get('/api/v1/admin/investors', { params: defaultParams, signal });
    return unwrap(response);
  },
};

export default investorService;
